import { useOrganizationContext } from "@/contexts/OrganizationContext";
import { useSessionContext } from "@/contexts/SessionContext";
import { clinicLabel, isVisibleClinicRole } from "@/utils/clinicRoleOptions";
import { Business } from "@mui/icons-material";
import {
  FormControl,
  ListItemText,
  ListItemIcon,
  MenuItem,
  Select,
  styled,
  Skeleton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// Estilo customizado para o Select no header
const StyledSelect = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(0, 2),
  minWidth: 200,
  "& .MuiOutlinedInput-root": {
    color: "white",
    "& fieldset": {
      borderColor: "rgba(255, 255, 255, 0.5)",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
  },
  "& .MuiSelect-icon": {
    color: "white",
  },
  "& .MuiInputBase-input": {
    padding: "8px 14px",
  },
}));

const HeaderOrganizationSelect: React.FC = () => {
  const { organization, organizationList, loading } = useOrganizationContext();
  const { roles, setAccess } = useSessionContext();

  function getRoles(data: any) {
    return [
      ...(data?.isManager ? ["manager"] : []),
      ...(data?.isPractitioner ? ["practitioner"] : []),
      ...(data?.isOwner ? ["owner"] : []),
      ...(data?.isInvited ? ["invited"] : []),
    ];
  }

  const activeOrganizations =
    roles?.filter((role) => isVisibleClinicRole(role, organizationList)) || [];

  const navigate = useNavigate();

  const handleChange = (data?: any) => {
    const auxOrganizationId = data.organization.reference
      ?.split("/")[1]
      ?.split("-")[1];

    setAccess({
      type: "professional",
      organizationId: auxOrganizationId,
      roles: getRoles(data),
    });

    localStorage.setItem("organizationId", auxOrganizationId);
    navigate("/");

    //verificar contratos da clinica selecionada
    //verificar se é profissional alem de owner e manager
    // redirecionar para tela de perfil com cancelamento aberto se tiver recusado o termo
  };

  return (
    <StyledSelect>
      {loading ? (
        <Skeleton variant="rectangular" width="100%" height={40} />
      ) : (
        <>
          <Select
            value={organization?.id?.split("-")[1] || ""}
            onChange={handleChange}
            sx={{ color: "white" }}
            renderValue={(selected) => {
              if (!selected) return "Selecione uma clínica";
              const role = roles?.find((r) => {
                return r.organization?.reference?.split("-")[1] === selected;
              });

              return clinicLabel(role, organizationList);
            }}
            startAdornment={<Business sx={{ mr: 1, color: "white" }} />}
          >
            {activeOrganizations.length > 0 ? (
              activeOrganizations.map((el) => (
                <MenuItem
                  value={
                    el.organization?.reference?.split("/")[1]?.split("-")[1]
                  }
                  onClick={() => handleChange(el)}
                  key={`org-select-${el.organization?.display}`}
                >
                  <ListItemIcon>
                    <Business />
                  </ListItemIcon>

                  <ListItemText
                    primary={clinicLabel(el, organizationList)}
                  />
                </MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                Nenhuma organização ativa encontrada
              </MenuItem>
            )}
          </Select>
        </>
      )}
    </StyledSelect>
  );
};

export { HeaderOrganizationSelect };
